/**
 * @file Определения функций сортировки для каталога.
 * Экспортирует объект с именованными компараторами, применяемыми к отфильтрованным элементам каталога.
 */

/**
 * Сортирует элементы по числовому свойству в убывающем порядке.
 * При равных значениях сохраняет исходный порядок через `originalIndex`.
 * Элементы с null-значением помещаются в конец.
 * @param {object} a
 * @param {object} b
 * @param {string} property - Имя числового свойства для сравнения.
 * @returns {number}
 */
function compareDescending(a, b, property) {
  const aValue = a[property]
  const bValue = b[property]

  if (aValue === bValue) return a.originalIndex - b.originalIndex
  if (aValue === null) return 1
  if (bValue === null) return -1

  return bValue - aValue
}

/**
 * Именованные компараторы сортировки каталога.
 * - `default` — исходный порядок элементов.
 * - `high-rating` — виджет, затем рейтинг, затем заполненность карточки.
 * - `new` — по убыванию даты создания.
 * @type {Object.<string, function(object, object): number>}
 */
const sortDefinitions = {
  'default': function (a, b) {
    return a.originalIndex - b.originalIndex
  },

  // Повторяет серверную формулу (ClubsController#catalog_clubs): установленный
  // виджет, затем рейтинг, затем заполненность карточки, затем порядок разметки
  // (число отзывов, id). Каждый ключ обязан быть и здесь: сортировка по
  // умолчанию — «high-rating», клиент применяет её сразу на загрузке, и любой
  // пропущенный ключ сбрасывал бы серверный порядок.
  'high-rating': function (a, b) {
    const byWidget = compareDescending(a, b, 'widget')
    if (byWidget !== 0) return byWidget

    const byRating = compareDescending(a, b, 'rating')
    if (byRating !== 0 && a.rating !== b.rating) return byRating

    const byCompleteness = compareDescending(a, b, 'completeness')
    if (byCompleteness !== 0) return byCompleteness

    return a.originalIndex - b.originalIndex
  },

  'new': function (a, b) {
    return compareDescending(a, b, 'createdAt')
  }
}

export default sortDefinitions
